import React, { FC } from 'react'

import classes from './TickCircle.module.scss'
import colorsJson from '../../colors.json'
import { Tick } from '../tick'

const { colors } = colorsJson

export const TickCircle: FC = () => {
  const color = colors['Brand/PrimaryGreen']
  return (
    <span className={classes.tickCircleWrapper} data-testid="tick-circle-icon">
      <Tick color={color} />
    </span>
  )
}

export default TickCircle
